import {
  Box,
  Typography,
  Switch,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSetterRestrictedMode } from 'redux/slices';

export function SetterBalanceToggle() {
  const { setterRestrictedMode } = useSelector((state) => state.game);
  const dispatch = useDispatch();

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Typography>Levantador restrito</Typography>
      <Switch
        checked={setterRestrictedMode}
        onChange={() => dispatch(toggleSetterRestrictedMode())}
        size="small"
      />
    </Box>
  );
}
